import { GuardianService } from '../_services/guardian.service';
import { AuthService } from '../_services/auth.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";

@Injectable()
export class StudentEnrolmentGuard {
    constructor(
        private router: Router,
        private guardianService:GuardianService,
        private authService: AuthService) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        let studentId = +route.paramMap.get('server_student_user_id')
        let ids = this.guardianService.getServerStudentUserIds()
        if(ids.includes(studentId) || (this.authService.isAdmin())){
            return true
        }else{
            this.router.navigate(['/notfound'])
            return false
        }
    }


}
